"use strict";
exports.__esModule = true;
var ChartDataTable = /** @class */ (function () {
    function ChartDataTable(_a) {
        var columns = _a.columns, rows = _a.rows;
        var _this = this;
        this.toJSON = function () { return ({
            columns: _this.columns,
            rows: _this.rows
        }); };
        this.columns = columns;
        this.rows = rows;
    }
    ChartDataTable.fromJSON = function (json) {
        var _a = Object.assign({}, json), columns = _a.columns, rows = _a.rows;
        if (!Array.isArray(columns) && columns !== undefined)
            throw new Error('.columns must be an array');
        if (!Array.isArray(rows) && rows !== undefined)
            throw new Error('.rows must be an array');
        return new ChartDataTable({
            columns: columns,
            rows: rows
        });
    };
    return ChartDataTable;
}());
exports["default"] = ChartDataTable;
